enum TCampaignDuration {
  twelveMonths = "twelveMonths",
  sixMonths = "sixMonths",
  threeMonths = "threeMonths",
}

type TTrackingCampaign = {
  id: number;
  period_start: string;
  period_end: string;
  employees: number;
  turnover: number;
  score_id: number;
  finished: boolean;
  review_id: number;
};

export type { TTrackingCampaign };
export { TCampaignDuration };
